import _ from 'underscore';
import { UAPImageExpansionType, UAPCroppingType } from './constants';

export const getExpandedImageUrl = (imageExpansionType, src, paddingColor, expandedImageWidth, expandedImageHeight) => {
  if (!imageExpansionType || imageExpansionType === UAPImageExpansionType.None) {
    // no expanded image
    return null;
  }

  const hasQuery = !_.isEmpty(src) && src.indexOf('?') > 0;
  const srcWithQuery = hasQuery ? src : `${src}?`;
  let queryParams = '';
  if (imageExpansionType === UAPImageExpansionType.Outpainting) {
    queryParams = hasQuery ? '&ustim=1' : 'ustim=1';
  } else if (imageExpansionType === UAPImageExpansionType.WhitePadding
   || imageExpansionType === UAPImageExpansionType.SingleColorPadding
  ) {
    queryParams = `${hasQuery ? '&' : ''}w=${expandedImageWidth}&h=${expandedImageHeight}`;
    if (paddingColor) {
      const idx = paddingColor.indexOf('#');
      queryParams += `&pcl=${paddingColor.slice(idx + 1)}`;
    }
  }

  return `${srcWithQuery}${queryParams}`;
};

export const setROIInfo = (roiInfo, imageUrl) => {
  if (!roiInfo || !imageUrl) {
    return {};
  }
  try {
    const ROIInfoObj = JSON.parse(roiInfo);
    const imageExpansionType = ROIInfoObj.ImageExpansionType;
    const expandedImageWidth = imageExpansionType === UAPImageExpansionType.Outpainting ? ROIInfoObj.ThumbnailWidth : ROIInfoObj.PaddingImageWidth;
    const expandedImageHeight = imageExpansionType === UAPImageExpansionType.Outpainting ? ROIInfoObj.ThumbnailHeight : ROIInfoObj.PaddingImageHeight;
    const paddingColor = ROIInfoObj.PaddingColor;
    const expandedImageCropSettings = ROIInfoObj.ImageCropSetting ? _.map(ROIInfoObj.ImageCropSetting, ({ aspectRatio, cropSetting: cs }) => ({
      AspectRatio: aspectRatio,
      CropSetting: {
        SourceHeight: cs.sourceHeight, SourceWidth: cs.sourceWidth, SourceX: cs.sourceX, SourceY: cs.sourceY,
      },
    })) : null;
    const croppingType = imageExpansionType === UAPImageExpansionType.Outpainting ? UAPCroppingType.CenterCrop : UAPCroppingType.SmartCrop;
    const originalImageCropSettings = ROIInfoObj.OriginalImageCropSetting ? _.map(ROIInfoObj.OriginalImageCropSetting, ({ aspectRatio, cropSetting: cs }) => ({
      AspectRatio: aspectRatio,
      CropSetting: {
        SourceHeight: cs.sourceHeight, SourceWidth: cs.sourceWidth, SourceX: cs.sourceX, SourceY: cs.sourceY, CroppingType: croppingType,
      },
    })) : null;
    const expandedImageUrl = getExpandedImageUrl(imageExpansionType, imageUrl, paddingColor, expandedImageWidth, expandedImageHeight);

    return {
      expandedImageWidth,
      expandedImageHeight,
      expandedImageCropSettings,
      originalImageCropSettings,
      expandedImageUrl,
      imageExpansionType,
      paddingColor,
    };
  } catch (e) {
    return {};
  }
};
